<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<idt-common-styles-render
  *ngIf="piece"
  [styles]="piece.settings.styles">
  <menu>
    <div class="artwork">
      <img
        src="{{ currentCategory.artwork }}"
        alt="{{ currentCategory.alt ?? '' }}"
        [attr.height]="maxCategoryHeight"
        [attr.title]="currentCategory.title">
      <div class="artwork-text">
        <div
          *ngIf="currentCategory.header"
          class="artwork-header">
          <render-wysiwyg
            [html]="currentCategory.header.text"
            [piece]="piece"
            [textPaddingTop]="currentCategory.header.textPaddingTop"
            [textPaddingBottom]="currentCategory.header.textPaddingBottom"
            [textPaddingLeft]="currentCategory.header.textPaddingLeft"
            [textPaddingRight]="currentCategory.header.textPaddingRight">
          </render-wysiwyg>
        </div>
        <div
          *ngIf="currentCategory.cover"
          class="artwork-cover">
          <render-wysiwyg
            [html]="currentCategory.cover.text"
            [piece]="piece"
            [textPaddingTop]="currentCategory.cover.textPaddingTop"
            [textPaddingBottom]="currentCategory.cover.textPaddingBottom"
            [textPaddingLeft]="currentCategory.cover.textPaddingLeft"
            [textPaddingRight]="currentCategory.cover.textPaddingRight">
          </render-wysiwyg>
        </div>
        <div
          *ngIf="currentCategory.footer"
          class="artwork-footer">
          <render-wysiwyg
            [html]="currentCategory.footer.text"
            [piece]="piece"
            [textPaddingTop]="currentCategory.footer.textPaddingTop"
            [textPaddingBottom]="currentCategory.footer.textPaddingBottom"
            [textPaddingLeft]="currentCategory.footer.textPaddingLeft"
            [textPaddingRight]="currentCategory.footer.textPaddingRight">
          </render-wysiwyg>
        </div>
      </div>
    </div>
    <div class="menu-items">
      <menuitem *ngFor="let artwork of selectedCategories; trackBy: trackByIndex">
        <a
          [attr.href]="getCategoryUrl(artwork) | async"
          (mouseenter)="selectCategory(artwork, orientation)">
          {{ artwork.name }}
        </a>
      </menuitem>
    </div>
  </menu>
</idt-common-styles-render>
